// Ödeme Kontrol Raporu penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.paymentVerification';

export const paymentVerificationGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Ödeme Kontrol Raporu nasıl okunur?'),
  intro: t(`${G}.intro`, 'Paket ekranındaki "KONTROL YAP" düğmesi bu raporu açar. Rapor yalnız kontrol eder; hiçbir kaydı değiştirmez. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Özet ve sipariş tabloları'),
    footer: t(`${G}.regions.footer`, 'Yeniden Kontrol Et'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Rapor neyi kontrol eder?'),
      text: t(`${G}.s1.text`, 'Ekranda yüklü siparişleri günün satış fişleriyle karşılaştırır ve her sipariş için fatura, fiş ve ödeme kaydı oluşmuş mu diye bakar. Gün sabah 05:00\'te başlar, ertesi sabah 05:00\'te biter.'),
      tips: [
        t(`${G}.s1.tip1`, 'Siparişler Telefon Siparişleri, Getir, Migros, Yemeksepeti ve Uber Eats başlıkları altında gruplanır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Özet kartlarını okuyun'),
      text: t(`${G}.s2.text`, 'Üstte Toplam Sipariş, Sorunsuz, Uyarı ve Hata sayıları görünür. Tablolarda sorunlu satırlar renklidir: kırmızı hata, sarı uyarı.'),
      tips: [
        t(`${G}.s2.tip1`, 'Sorunsuz: sipariş ödenmiş; fatura, fiş ve ödeme detayı tam.'),
        t(`${G}.s2.tip2`, 'İptal edilen siparişler "İptal" etiketiyle sorunsuz sayılır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Durum mesajlarının anlamı'),
      text: t(`${G}.s3.text`, 'Durum sütunundaki mesaj eksik olan kaydı söyler.'),
      tips: [
        t(`${G}.s3.tip1`, 'Hata – "Ödeme alınmış fakat fatura ve fiş kaydı yok": para alınmış ama satış kaydı oluşmamış.'),
        t(`${G}.s3.tip2`, 'Uyarı – "Fatura var fakat fiş kaydı yok" / "Fiş var fakat fatura kaydı yok": kayıtlardan biri eksik.'),
        t(`${G}.s3.tip3`, 'Uyarı – "Fiş var fakat ödeme detayı yok": fişte ödeme yöntemi bilgisi yok.'),
        t(`${G}.s3.tip4`, 'Uyarı – "Ödenmemiş fakat kayıt mevcut": sipariş ödenmemiş görünüyor ama fatura veya fiş var.'),
        t(`${G}.s3.tip5`, 'Uyarı – "Ödeme bekliyor": siparişin ödemesi henüz alınmamış.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Sorunları düzeltin'),
      text: t(`${G}.s4.text`, 'Düzeltme bu pencereden yapılmaz. "Ödeme bekliyor" satırları için paket ekranında siparişi seçip "ÖDEME AL" ile ödemeyi alın. Hata ve diğer uyarılarda sipariş numarasını not edip yöneticinize iletin.'),
      tips: [
        t(`${G}.s4.tip1`, 'Aynı kısa kod iki markada görülürse ve tutar da ayırt etmiyorsa fiş eşleştirilmez; böyle bir sipariş uyarı olarak görünebilir.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Yeniden kontrol edin'),
      text: t(`${G}.s5.text`, 'Ödeme aldıktan veya kayıt düzeltildikten sonra "Yeniden Kontrol Et"e basın; rapor güncel kayıtlarla yeniden hazırlanır. "Kapat" pencereyi kapatır. Başlıktaki (i) bu rehberi açar.'),
    },
  ],
});
